import(/* webpackMode: "eager" */ "/var/www/html/testprep-frontend/components/layouts/provider-component.tsx")